<script setup lang="ts">
import { ref, watch } from 'vue';
import { ListTask } from "@/interfaces/data-contracts";
import adminAPI from '@/services/api';

import BaseButton from '@/components/ui/buttons/BaseButton.vue';

const props = defineProps<{ claimId: string}>();

const tasks = ref<ListTask>([]);

watch(() => props.claimId, async (newClaimId) => {
  tasks.value = await adminAPI.listClaimTasks(newClaimId);
}, { immediate: true });
</script>

<template>
  <div v-if="tasks?.length" class="px-4 py-4 text-left sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-base font-semibold leading-6 text-gray-900">Tâches en cours</h1>
        <p class="mt-2 text-sm text-gray-700">Rappels connectés à Slack.</p>
      </div>
      <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
        <BaseButton text="Tâches terminées" size="lg" />
      </div>
    </div>
    <div class="mt-10 -mx-4 shadow ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
      <table class="min-w-full divide-y divide-gray-300">
        <thead>
          <tr>
            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Assigné</th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Titre</th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Date</th>
            <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
              <span class="sr-only">Done</span>
            </th>
            <!-- <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Demandé par</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(task, taskIdx) of tasks" :key="task.id">
            <td :class="[taskIdx === 0 ? '' : 'border-t border-transparent', 'relative py-4 pl-4 pr-3 text-sm sm:pl-6']">
              <div class="font-medium text-gray-900">
                {{ task.assignedAdmin?.fullName }}
              </div>
              <div v-if="taskIdx !== 0" class="absolute right-0 h-px bg-gray-200 -top-px left-6" />
            </td>
            <td :class="[taskIdx === 0 ? '' : 'border-t border-gray-200', 'hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell']">
              {{ task.title }}
            </td>
            <td :class="[taskIdx === 0 ? '' : 'border-t border-gray-200', 'hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell']">
              <div class="font-medium text-gray-900">
                {{ new Date(task.dueDate).toLocaleDateString() }}
                <span v-if="task.completedAt" class="ml-1 text-indigo-600">(Terminée)</span>
              </div>
            </td>
            <td :class="[taskIdx === 0 ? '' : 'border-t border-transparent', 'relative py-3.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6']">
              <button type="button" class="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                 :disabled="Boolean(task.completedAt)"
                 v-tooltip="'Via Slack pour l\'instant'"
              >
                Terminé<span class="sr-only">, {{ task.title }}</span>
              </button>
              <div v-if="taskIdx !== 0" class="absolute left-0 h-px bg-gray-200 -top-px right-6" />
            </td>
            <!-- <td :class="[taskIdx === 0 ? '' : 'border-t border-gray-200', 'hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell']">
              {{ task.creator?.fullName }}
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>